import { useRef, useCallback } from 'react';

/**
 *
 * @param func The original, non debounced function (You can pass any number of args to it)
 * @param delay The delay (in ms) for the function to return
 * @returns The debounced function, which will run only if the debounced function has not been called in the last (delay) ms
 */
const useDebounce = (func, delay = 600) => {
    const timer = useRef();
    const debouncedFunction = useCallback(((...args) => {
        const newTimer = setTimeout(() => {
            func(...args);
        }, delay);
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = newTimer;
    }), [func, delay]);
    return debouncedFunction;
};

export { useDebounce };
